import { object, string } from "yup";

export const commentValidationSchema = object().shape({
  comment: string()
    .trim()
    .required("Description should be between 15 and 200 characters.")
    .min(15, "Description should be between 15 and 200 characters.")
    .max(200, "Description should be between 15 and 200 characters."),
});



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/change-status-modal/commentValidationSchema.js